import type { FC, ReactNode } from "react";
import { imageLinks } from "../../helpers/imageLinks.js";

interface OnboardingShellProps {
  children: ReactNode;
  onSignOut: () => void;
  /** Label for the escape-hatch link below the card. */
  signOutLabel?: string;
}

/**
 * Presentational chrome shared by the name-only onboarding form and the
 * account-resolution screens, matching the sign-in screen: a fixed logo and a
 * centered card, with a sign-out escape hatch below the card. Side effects
 * (the actual sign-out) are passed in via `onSignOut`.
 */
export const OnboardingShell: FC<OnboardingShellProps> = ({
  children,
  onSignOut,
  signOutLabel = "Sign out",
}) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 sm:px-6 lg:px-8">
      <img
        src={imageLinks.LOGO_BLUE}
        alt="Alpharun"
        className="fixed top-8 mx-auto h-5"
      />
      <div className="w-full max-w-md">
        <div className="rounded-lg bg-white px-6 py-10 shadow-sm sm:rounded-lg">
          {children}
        </div>
        <div className="mt-4 text-center">
          <button
            className="text-sm font-medium text-blue-600 hover:text-blue-500"
            onClick={onSignOut}
          >
            {signOutLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
